<template>
  <div>
    <div class="row">
      <div class="col-sm-8 col-sm-offset-2">
        <p class="small">
          You have a UK registered business entity or are serviced by an Umbrella Company and have
          an active contract with a gross payout agreement. Therefore we need to collect some
          mandatory information from you before you can get paid, so that HMRC can be informed about
          your gross earnings via Worksome.
        </p>
      </div>
    </div>

    <div class="form-group p-t-30">
      <label class="col-md-4 control-label" for="uk_tax_national_insurance_number">
        National insurance number *
      </label>

      <div class="col-md-6 col-xs-8">
        <input
          id="uk_tax_national_insurance_number"
          v-model="form.taxNationalInsuranceNumber"
          name="uk_tax_national_insurance_number"
          type="text"
          :required="isNiNumberRequired"
          class="form-control"
        />

        <div class="f-12 c-gray">
          This information is required to report your gross income payouts based on HMRC guidelines.
          If you do not want to share your NI number, you can instead opt to share your sex and date
          of birth.
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label"></label>

      <div class="col-md-6 col-xs-8">
        <div class="checkbox">
          <label>
            <input type="hidden" name="uk_tax_share_information" value="false" />

            <input
              v-model="form.taxShareInformation"
              name="uk_tax_share_information"
              type="checkbox"
              value="true"
            />

            <i class="input-helper" />
            I do not want to share my NI number
          </label>
        </div>
      </div>
    </div>

    <div v-if="form.taxShareInformation === true" class="form-group">
      <label class="col-md-4 control-label" for="uk_tax_sex">Sex *</label>

      <div class="col-md-6 col-xs-8">
        <select id="uk_tax_sex" v-model="form.gender" name="uk_tax_sex" class="form-control">
          <option :value="null" selected>Choose your sex</option>
          <option value="M">Male</option>
          <option value="F">Female</option>
        </select>
      </div>
    </div>

    <div v-if="form.taxShareInformation === true" class="form-group">
      <label class="col-md-4 control-label" for="uk_tax_date_of_birth">Date of birth *</label>

      <div class="col-md-6 col-xs-8">
        <input
          id="uk_tax_date_of_birth"
          v-model="form.dateOfBirth"
          name="uk_tax_date_of_birth"
          type="text"
          class="form-control"
          placeholder="DD/MM/YYYY"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-6 col-sm-offset-4 col-xs-12">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <SubmitButton class="m-t-30" :text="$t('Save')" auto-submit :disabled="!canSave" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    taxNationalInsuranceNumber: {
      type: String,
      required: true,
    },

    taxShareInformation: {
      type: Boolean,
      required: true,
    },

    gender: {
      type: String,
      required: true,
    },

    dateOfBirth: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      form: {
        taxNationalInsuranceNumber: this.taxNationalInsuranceNumber,
        taxShareInformation: this.taxShareInformation,
        gender: this.gender,
        dateOfBirth: this.dateOfBirth,
      },
    }
  },

  computed: {
    isNiNumberRequired() {
      return !this.form.taxShareInformation
    },
    canSave() {
      if (this.form.taxShareInformation) {
        return this.form.gender && this.form.dateOfBirth
      }

      return true
    },
  },
}
</script>
